module.exports = __webpack_public_path__ + "static/MR_APR19_A_Steady_Rain_600x600px-56fa4331315c3f5a4015d14424539a29.jpg";